import { get, update, post, remove } from "../helper/apiMethods";
import makeToast from "../components/Snackbar";

export const getAllClients = async () => {
	try {
		const res = await get("/client/ListofClients")
		return res
	} catch (error) {
		return Promise.reject(error);
	}
}
export const getClientById = async (id: string) => {
	try {
		const res = await get(`/client/${id}`)
		return res
	} catch (error) {
		return Promise.reject(error);
	}
}
//i need type on values for protection
export const addClient = async (values) => {
	try {
		const res = await post("/client/addClient",values)
		return res
	} catch (error) {
		return Promise.reject(error);
	}
}
//i need type on values for protection
export const updateClient = async (id: string, values) => {
	try {
		const res = await update(`/client/update/${id}`, values)
		return res
	} catch (error) {
		return Promise.reject(error);
	}
}
export const deleteClient = async (id: string) => {
	try {
		const res = await remove(`/client/delete/${id}`)
		return res
	} catch (error) {
		return Promise.reject(error);
	}
}
export const syncronizeClient = async (code?: string) => {
    const url = code ? `client/sync/clientlist?code=${code}` : `client/sync/clientlist`;
    const res = await get(url);
    return res;
}